import React from 'react'
import { LoungeConfigurationScreen } from '@/screens/lounges/LoungeConfigurationScreen'

export default function LoungeConfigurationRoute() {
  return <LoungeConfigurationScreen />
}
